var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-footer',{attrs:{"app":"","inset":""}},[_c('span',[_vm._v(_vm._s(_vm.$t('lbl.footer_text'))+" - v 2.0.5")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }